export default __webpack_public_path__ + "static/media/naidi-1-2.57c59b47.svg";